import React, { useState, useRef, useEffect, useContext } from "react";
import ProfileColPagesssContext from "../../../context/ProfileColPagesssContext";
import { useTranslation } from "react-i18next";
import "./Navbarcolpagesss.css";
import {
  FaRegFileAlt,
  FaUserCog,
  FaSignOutAlt,
  FaCogs,
} from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { clearToken } from "../../../utils/auth";
import { DashboardContext } from "../../../context/DashboardPageContext";

export default function Navbarcolpagesss() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { profilecolpagesssData, setProfilecolpagesssData } = useContext(ProfileColPagesssContext);
  // console.log(profilecolpagesssData)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const handleLogout = () => {
  //   setDropdownOpen(false);
  //   setShowLogoutPopup(true);
  // };
  const handleLogout = () => {
    clearToken();
    localStorage.removeItem("collectorUser");
    localStorage.removeItem("authToken");
    navigate("/");
  };

  const handleConfirmLogout = () => {
    // logout logic
    navigate("/");
    setShowLogoutPopup(false);
  };

  const handleCancelLogout = () => {
    setShowLogoutPopup(false);
  };
 const profileImage =
  profilecolpagesssData?.profilePicture || "/default-user.png";

  return (
    <>
      <header className="navbarcolpagesss-container">
        <div className="navbarcolpagesss-left">
        <h1 className="navbarcolpagesss-logo">{t("appName")}</h1>


        </div>

        <div className="navbarcolpagesss-right">
          {/* <div className="navbarcolpagesss-daterange">
            <MdDateRange className="navbarcolpagesss-icon" />
            <div className="navbarcolpagesss-dateinputs">
              <div className="navbarcolpagesss-dateinput">
                <label>Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="navbarcolpagesss-dateinput">
                <label>End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div> */}

          <div
            className="navbarcolpagesss-item"
            onClick={() => navigate("/reportcolpagesss")}
            style={{ cursor: "pointer" }}
          >
            <FaRegFileAlt className="navbarcolpagesss-icon" />
            <span>{t("reports")}</span>
          </div>

          <div
            className="navbarcolpagesss-item profile-menu"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            ref={dropdownRef}
          >
            <FaUserCog />

            {dropdownOpen && (
              <div className="profile-dropdown">
                <div className="profile-header">
                 <img
    src={profileImage}
    alt="profile"
    className="demo-profile-icon"
    style={{ width: 45, height: 45, borderRadius: "50%" }}
  />

                  <div>
                    <p className="profile-name">
                      {profilecolpagesssData?.name}
                    </p>

                    <span className="profile-role">
                      {profilecolpagesssData?.dept}
                    </span>

                  </div>
                </div>

                <hr />

                <ul className="profile-options">
                <li onClick={() => navigate("/profileColPagesss")}>
  <FaCogs style={{ color: "black" }} /> {t("settings")}
</li>

                  <li className="logout-btn" onClick={handleLogout}>
  <FaSignOutAlt style={{ color: "black" }} /> {t("logout")}
</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* LOGOUT POPUP */}
      {showLogoutPopup && (
        <div className="logout-overlay">
          <div className="logout-popup">
            <h3>{t("logoutConfirm")}</h3>
            <div className="popup-actions">
             <button className="yes-btn" onClick={handleConfirmLogout}>
  {t("yes")}
</button>
             <button className="no-btn" onClick={handleCancelLogout}>
  {t("no")}
</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
